import { render, staticRenderFns } from "./dailyJournalCategories.vue?vue&type=template&id=81316ef2&"
import script from "./dailyJournalCategories.vue?vue&type=script&lang=js&"
export * from "./dailyJournalCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports